import { gettext } from '@eventbrite/i18n';
import React from 'react';

export type ShareInlineProps = {
    hasShareInline: boolean;
};

export const ShareInline = ({ hasShareInline }: ShareInlineProps) => {
    if (!hasShareInline) {
        return null;
    }

    return (
        <section aria-labelledby="share-inline-heading">
            <div className="l-sm-mar-bot-4">
                <h3
                    id="share-inline-heading"
                    className="label-primary normal-case l-sm-align-left"
                >
                    {gettext('Share with friends')}
                </h3>
                <div id="listings-root__share-event"></div>
            </div>
        </section>
    );
};
